import { createListenerMiddleware } from "@reduxjs/toolkit";

// Side effects (storage, DOM) go here.
export const listenerMiddleware = createListenerMiddleware();
